import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

export default function CrmModuleBreakdownChart({ stats }) {
  const data = [
    { name: 'Contacts', value: stats.contacts },
    { name: 'Properties', value: stats.properties },
    { name: 'Tasks', value: stats.tasks },
    { name: 'Notes', value: stats.notes },
    { name: 'Lead Stages', value: stats.leadStages },
    { name: 'Notifications', value: stats.notifications },
    { name: 'AI Fields', value: stats.aiFields },
  ];
  return (
    <Paper sx={{ p: 3, height: 340 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        CRM Module Breakdown
      </Typography>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="value" fill="#1976d2" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
